import { LinkedinChange, LinkedinChangeKind } from "../types/linkedin";
import { formatCurrency } from "./format";

export const CHANGE_DOT_COLORS: Record<LinkedinChangeKind, string> = {
  bid: "brandOrange",
  budget: "accent",
};

// Amounts are compared at the cent, as they're displayed, so the
// headline never claims a move the figures beside it don't show.
const cents = (amount: number): number => Math.round(amount * 100);

// What happened, as the log's headline. Only the positive is ever
// claimed: a budget the customer set reads as "set", never as the agent
// raising or lowering it.
export const changeLabel = (change: LinkedinChange): string => {
  const { kind, source } = change;
  const after = cents(change.after);
  const before = cents(change.before);
  if (kind === "bid") {
    if (after < before) return "Bid lowered";
    if (after > before) return "Bid raised";
    return "Bid reset";
  }
  if (source === "external" || after === before) return "Daily budget set";
  return after < before ? "Daily budget lowered" : "Daily budget raised";
};

export const changeDetail = (change: LinkedinChange): string => {
  const currency = change["currency-code"];
  return cents(change.after) === cents(change.before)
    ? formatCurrency(change.after, currency)
    : `${formatCurrency(change.before, currency)} → ${formatCurrency(change.after, currency)}`;
};
